class CustomSellingPlans extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addSubOptionListeners();
  }

  addSubOptionListeners() {
    const subInputElems = this.querySelectorAll('.js-sub-input');
    subInputElems.forEach(inputEl => {
      inputEl.addEventListener('change', this.onSubInputChange.bind(this));
    })
  }

  onSubInputChange(e) {
    const newSellingPlanId = e.target.value;
    const sellingPlanInputEl = e.target.closest('.js-selling-plan-item')?.querySelector('.js-selling-plan-input');

    if (!sellingPlanInputEl || !newSellingPlanId) return;
    sellingPlanInputEl.value = newSellingPlanId;
  }
}

customElements.define('custom-selling-plans', CustomSellingPlans);

class customQuantities extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const discounNoPlanBadges = this.querySelectorAll(".js-discount--one-time");
    const discounPlanBadges = this.querySelectorAll(".js-discount--subscription");
    const sellingPlanInputElems = this.closest("[data-product-blocks]").querySelectorAll('[name="selling_plan"]');
    const quantityInputElems = this.closest("[data-product-blocks]").querySelectorAll('[name="quantity"]');
    sellingPlanInputElems.forEach(el => {
      el.addEventListener('change', (e) => {
        const sellingPlanId = e.currentTarget.value;
        discounNoPlanBadges.forEach(el => {
          el.classList.toggle('custom-quantity__badge--active', !sellingPlanId);
        })

        discounPlanBadges.forEach(el => {
          el.classList.toggle('custom-quantity__badge--active', sellingPlanId);
        })

        this.definePrice();
      })
    })

    quantityInputElems.forEach(el => {
      el.addEventListener('change', (e) => {
        this.definePrice();
      })
    })
  }

  definePrice() {
    const currentQuantityInputEl = this.closest("[data-product-blocks]")?.querySelector('[name="quantity"]:checked');
    const currentQuantity = Number(currentQuantityInputEl?.value);
    const oneTimeDiscountValue = Number(currentQuantityInputEl.dataset.discountOneTime);

    const basicPriceEl = this.closest("[data-product-blocks]")?.querySelector('[data-basic-price]');
    const basicComparedPriceEl = this.closest("[data-product-blocks]")?.querySelector('[data-basic-compared-price]');
    const basicPriceWithPlanEl = this.closest("[data-product-blocks]")?.querySelector('[data-plan-price]');
    const basicPriceWithPlanElems = this.closest("[data-product-blocks]")?.querySelectorAll('.js-plan-price');

    const basicPrice = Number(basicPriceEl?.dataset.basicPrice);
    const basicComparedPrice = Number(basicComparedPriceEl?.dataset.basicComparedPrice);
    const basicPriceWithPlan = Number(basicPriceWithPlanEl?.dataset.planPrice);

    if (basicPriceEl) {
      console.debug({
        base: Shopify.formatMoney(oneTimeDiscountValue ? basicPrice * currentQuantity * (100 - oneTimeDiscountValue) / 100 : basicPrice * currentQuantity),
        new: Shopify.formatMoney(oneTimeDiscountValue ? basicPrice * currentQuantity * (100 - oneTimeDiscountValue) / 100 : basicPrice * currentQuantity, "${{amount_no_decimals}}")
      });
      
      // basicPriceEl.innerHTML = Shopify.formatMoney(oneTimeDiscountValue ? basicPrice * currentQuantity * (100 - oneTimeDiscountValue) / 100 : basicPrice * currentQuantity);
      basicPriceEl.innerHTML = Shopify.formatMoney(oneTimeDiscountValue ? basicPrice * currentQuantity * (100 - oneTimeDiscountValue) / 100 : basicPrice * currentQuantity, "${{amount_no_decimals}}");
    }
    
    if (basicComparedPriceEl) {
      basicComparedPriceEl.innerHTML = Shopify.formatMoney(basicComparedPrice * currentQuantity);
    }
    
    basicPriceWithPlanElems.forEach(el => {
      el.innerHTML = Shopify.formatMoney(basicPriceWithPlan * currentQuantity);
    })
  }
}

customElements.define('custom-quantities', customQuantities);
